/*
----- Axis Toggler ----- 
This is primarily built on foundation's toggler plugin https://get.foundation/sites/docs/toggler.html but we needed some extra functionality which latches on the events that get fired.
*/

function initialiseAll() {
    // Find all instances.
    let elements = $('[' + expressSelectors()['axis-toggler']['initialise'] + ']');
    // Loop through them.
    elements.each(function() {
        // Grab context.
        let context = $(this);
        // Initialise.
        let init = initialise(context);
    });
    // Add blur overlay disabled listener.
    $(document).on('blur-disabled', function() {
        if (AXISDebug.level() >= 4) {
            AXISDebug.output(1,"Axis Toggler: Blur overlay disabled closing all active toggler instances.");
        }
        // Find active toggle.
        let context  = $('[data-toggler].active');
        
        if (context.attr('data-toggler') != undefined) {
            // Toggle it!.
            context.foundation('toggle');
        }
    });
}

function initialise(context) {
    // Add listeners.
    let listeners = addEventListeners(context);
}

// Add event listeners.
function addEventListeners(context) {
    // Fires if the target element has the class after a toggle.
    context.on('on.zf.toggler', function(event) {
        // Prevent bubbling as this can cause issue when nesting toggler which can cause functionality from pre-maturely triggering.
        event.stopPropagation();
        // What type of event is this?
        let type = event['type'];
        // Get the target.
        let target = $(event['target']);
        // Check whether we should blur content.
        let blur = (context.attr('data-blur-content') != undefined ? true : false);
        // If animated then what to toggle active state until transition finished.
        if (target.hasClass('animate')) {
            target.on('transitionend', function() {
                // Toggle active state.
                toggle();
                // Remove listener.
                target.off('transitionend');
            })
        } else {
            toggle();
        }
        // If blur enabled then blur background content + suppress body scroll bar.
        if (blur) {
            // Blur content behind.
            blurContent(target);
            // Suppress body scroll bar.
            bodyScrollLock();
        }

        // Find background.
        let toggleBackground = context.find('[' + expressSelectors()['axis-toggler']['background'] + ']');
        // If one doesn't exist then create one.
        if (!toggleBackground.length && !blur) {
            // Add markup to DOM.
            context.append('<div class="toggle-background" ' + expressSelectors()['axis-toggler']['background'] + '></div>');
            // Put background into context.
            toggleBackground = context.find('[' + expressSelectors()['axis-toggler']['background'] + ']');
            // Add click listener.
            toggleBackground.on('click', function() {
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1,"Axis Toggler: Toggling instance due to background being clicked", context);
                }
                // Toggle.
                context.foundation('toggle');
            });
        }
        
        // Used for toggling the active state on the target.
        function toggle() {
            // Add active state.
            target.addClass('active');
        }

        // Should we toggle when the mouse leaves the content.
        let toggleOnMouseLeave = (context.attr(expressSelectors()['axis-toggler']['content-leave']) != undefined);
        if (toggleOnMouseLeave) {
            context.on('mouseleave', function() {
                // Start close timer.
                let closeInterval = setInterval(() => {
                    // Stop interval.
                    clearInterval(closeInterval);
                    // Toggle.
                    context.foundation('toggle');
                    // Remove listeners.
                    context.off('mouseleave');
                    context.off('mouseenter');
                }, 1000);

                context.on('mouseenter', function() {
                    // Clear interval to keep dropdown open.
                    clearInterval(closeInterval);
                    // Remove listener.
                    context.off('mouseenter');
                });
            });
        }
    });
    //Fires if the target element does not have the class after a toggle.
    context.on('off.zf.toggler', function(event) {
        // Prevent bubbling as this can cause issue when nesting toggler which can cause functionality from pre-maturely triggering.
        event.stopPropagation();
        // What type of event is this?
        let type = event['type'];
        // Get the target.
        let target = $(event['target']);
        // Check whether we have blurred content.
        let blur = (context.attr('data-blur-content') != undefined ? true : false);
        // If animated then what to toggle active state until transition finished.
        if (context.attr('data-toggle-animate') != undefined) {
            // Toggle active state.
            toggle();
            // Only remove blur once the target transition has finshed.
            target.on('transitionend', function() {
                // If blur enabled then we need to de-blur the background content and re-enable body scroll bar.
                if (blur) {
                    // Check if blur is active.
                    if (getBlurContent(context).hasClass('blur')) {
                        // De-Blur content behind.
                        blurContent(target);
                    }
                    // Enable body scroll bar.
                    bodyScrollLock();
                }
                // Remove listener.
                target.off('transitionend');
            });
        } else {
            toggle();
            // If blur enabled then we need to de-blur the background content and re-enable body scroll bar.
            if (blur) {
                // De-Blur content behind.
                blurContent(target);
                // Enable body scroll bar.
                bodyScrollLock();
            }
        }
        // Remove background.
        let toggleBackground = context.find('[' + expressSelectors()['axis-toggler']['background'] + ']');
        if (toggleBackground.length && !blur) {
            // Remove listener.
            toggleBackground.off('click');
            // Remove element.
            toggleBackground.remove();
        }
        // Used for toggling the active state on the target.
        function toggle() {
            // Remove active state.
            target.removeClass('active');
        }
    });
}

var AXISToggler = $.AXISToggler = {
    initialiseAll: () => {
        return initialiseAll();
    },
    initialise: (context) => {
        return initialise(context);
    }
}
  
export { AXISToggler };